import { render, staticRenderFns } from "./logisticsTable.vue?vue&type=template&id=7ce30597&scoped=true"
import script from "./logisticsTable.vue?vue&type=script&lang=js"
export * from "./logisticsTable.vue?vue&type=script&lang=js"
import style0 from "./logisticsTable.vue?vue&type=style&index=0&id=7ce30597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce30597",
  null
  
)

export default component.exports